export default __webpack_public_path__ + "static/media/BG-ABOUT-01.2d1636e9.png";